function Card({ title, description, image }) {
  return (
    <div
      className="bg-white dark:bg-blue-950 shadow-md rounded-lg p-4 flex flex-col items-center
                    hover:border hover:border-blue-600 "
    >
      {" "}
      {image && (
        <img
          src={image}
          alt={title}
          className="w-full h-40 object-cover rounded-t-lg"
        />
      )}{" "}
      <h3 className="text-lg font-semibold mt-2 dark:text-white">{title}</h3>{" "}
      <p className="text-gray-600 mt-1 dark:text-white">{description}</p>{" "}
    </div>
  );
}
export default Card;
